import { render, staticRenderFns } from "./purchase_return_list.vue?vue&type=template&id=e460f57a&scoped=true"
import script from "./purchase_return_list.vue?vue&type=script&lang=js"
export * from "./purchase_return_list.vue?vue&type=script&lang=js"
import style0 from "./purchase_return_list.vue?vue&type=style&index=0&id=e460f57a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e460f57a",
  null
  
)

export default component.exports